module.exports = __webpack_public_path__ + "img/facebook_icon.c0d125fc.png";